<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样判定-编织</h1>-->
    <!--</header>-->
    <div class="mui-content">
      <div class="title-name">
        <span class="">取样判定-编织</span>
      </div>
       <div style="padding-top: 15px;">
         <div class="sampling-first-title">
           <h4 style="padding-left: 10px;font-size: 15px;font-weight: 500;">物料选择</h4>
         </div>
        <!--第一行-->
        <div class="form-group">
          <div class="input-label">
            <label >外注订单:</label>
          </div>
          <div class="form-input">
            <select  v-model="selectedContract" @change="clothQuery">
              <option v-for="item in contractList" :value="item.ddh">{{item.ddh}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="input-label">
            <label >物料:</label>
          </div>
          <div class="form-input">
            <select v-model="selectedWph" id="selCloth">
              <option v-for="item in clothList" :value="item">{{item.scxtwph+" "+item.scxtwpmc}}</option>
            </select>
          </div>
        </div>
        <div class="form-group" style="width:100%;margin-top: 30px;">
          <button type="button" class="mui-btn mui-btn-primary btn-blue" style="margin: auto;min-width: 80px;" id="samplingupdate" @tap="sampleupdate">取样</button>
          <button type="button" class="mui-btn mui-btn-default" style="margin: auto;min-width: 80px;" id="samplinghistorybtn" @tap="samplehis">取样履历</button>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
    export default {
      name: "samplingWeaving",
      data(){
        return{
          contractList:[],
          clothList:[],
          selectedContract:"",
          selectedWph:{}
        }
      },
      methods:{
        clothQuery(){
          var v=this;
          v.nyy.doPost("/Sample/getMateriaList",{ddh:v.selectedContract}, 
            function(result){
              if(result.status){
                 v.clothList=result.data.infoLst;
                 if(v.clothList.length>0){
                 v.selectedWph=v.clothList[0];
               }
              }else {
                  mui.toast(result.message);
                  return;
              }
            }
          );
        },
        sampleupdate(){
          var v=this;
          var para={ddh:v.selectedContract,wph:v.selectedWph.wph,scxtwph:v.selectedWph.scxtwph,scxtwpmc:v.selectedWph.scxtwpmc};
          this.$router.push({"name":"samplingWeavingUpdate",params: jsonPara(para)});
        },
        samplehis(){
          var v=this;
          var para={ddh:v.selectedContract,wph:v.selectedWph.wph,scxtwph:v.selectedWph.scxtwph,scxtwpmc:v.selectedWph.scxtwpmc};
          this.$router.push({"name":"samplingWeavingHis",params: jsonPara(para)});
        }
      },
      activated() {
        var v=this;
        v.nyy.doPost("/Sample/getContractList",{ddqf:"2"}, 
          function(result){
            if(result.status){
               v.contractList=result.data.infoLst;
               if(v.contractList.length>0){
                 v.selectedContract=v.contractList[0].ddh;
                 v.clothQuery();
               } else {
                  mui.toast(result.message);
                  return;
              }
            }
          }
        );
      }
    }
</script>

<style scoped>
  @import "../../static/css/samplinghistory.css";
  @import "../../static/css/filterorder.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingWeaving.vue